import { UserInfo } from '@spotify-internal/oauth-silent-authentication';

export const MOCK_USERNAME = 'Test User';

const mockUserInfo = {
  profile: { displayName: MOCK_USERNAME, username: MOCK_USERNAME },
  subject: '',
};

const silentAuth = {
  login: (url: string) => url,
  logout: (url: string) => url,
  getUserInfo: () =>
    new Promise<UserInfo>(resolve => {
      resolve(mockUserInfo);
    }),
  getToken: () => 'fakeAccessToken',
};

export default silentAuth;
